module.exports = __webpack_public_path__ + "static/media/20210410_190736_709_IMG_0308.e1b3442b.jpg";